import React from 'react';
import clsx from 'clsx';
import styles from './Box.module.scss';

interface Props {
  className?: string;
  children: React.ReactNode;
}

const Box = ({children, className}: Props): React.ReactElement => {
  return (
    <div className={clsx(styles.box, className)}>
      {children}
    </div>
  );
};

export default Box;
